import { withStyles } from "@bruitt/classnames";
import { forwardRef } from "react";

import s from "./base-button.module.scss";

const sx = withStyles(s);

type ElementProps = Omit<JSX.IntrinsicElements["button"], "ref">;

export interface BaseButtonProps extends ElementProps {}

export const BaseButton = forwardRef<HTMLButtonElement, BaseButtonProps>(
  ({ className, children, type = "button", ...rest }, ref) => {
    return (
      <button
        ref={ref}
        className={sx("button", className)}
        type={type}
        {...rest}
      >
        {children}
      </button>
    );
  },
);

BaseButton.displayName = "BaseButton";
